/**
 * version.js — versão do sistema exibida na UI.
 *
 * O valor vem de `VITE_APP_VERSION`, injetado como build arg pelo pipeline de
 * deploy a partir da **tag do Git** (ex.: `v1.4.0`). O Vite embute o valor no
 * bundle em tempo de build — não há chamada de rede nem estado de carregamento.
 *
 * Fora do pipeline (dev local, `npm run dev`) a variável não existe e cai no
 * fallback `dev`, deixando explícito que aquilo NÃO é um build versionado.
 *
 * Por que build-time e não runtime:
 *   A versão identifica o artefato. Buscá-la da API em runtime mostraria a
 *   versão do backend, que pode divergir do bundle servido ao navegador em
 *   janelas de deploy — justamente quando saber a versão importa.
 */

/** Versão do build (tag do Git) ou 'dev' fora do pipeline. */
export const APP_VERSION = import.meta.env.VITE_APP_VERSION ?? 'dev';

/**
 * Versão pronta para exibição, sempre prefixada com "v".
 *
 * Tags já vêm como `v1.4.0`; o prefixo só é adicionado quando falta, para não
 * produzir `vv1.4.0`.
 *
 * @returns {string} ex.: 'v1.4.0' · 'vdev'→'dev' (fallback mantém-se legível)
 */
export function displayVersion() {
  if (APP_VERSION === 'dev') return 'dev';
  return APP_VERSION.startsWith('v') ? APP_VERSION : `v${APP_VERSION}`;
}
